import React from 'react';
import Colors from '../../../utils/colors';

class Select extends React.Component {
  state = { value: '' };

  componentDidMount() {
    this.setState({ value: this.props.value || '' });
  }

  handleChange = (event) => {
    this.setState({ value: event.target.value });
    this.props.updateValue(event);
  }

  render() {
    const { field } = this.props;
    if (!field || !field.options || !field.options.length) {
      return null;
    }
    const color = Colors.inputColors(this.props.border);
    const classes = `block appearance-none w-full border ${color.border} text-grey-700 text-base py-2 px-4 pr-8 mb-2 rounded focus:outline-none ${color.focusBorder}`;
    const selectText = field.selectText || 'Select...';
    return (
      <div className="relative pb-1">
        <select className={classes}
          name={this.props.name}
          id={this.props.name}
          onChange={this.handleChange}
          disabled={!!this.props.submitting}
          value={this.state.value}
        >
          <option value="">{selectText}</option>
          {
            field.options.map(option => {
              // const selectedProp = option.value === this.state.value ? { selected: 'selected' } : {};
              const selectedProp = {};
              return (
                <option key={option.value} value={option.value} {...selectedProp}>{option.label}</option>
              );
            })
          }
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 mb-2 text-grey-700 text-base">
          <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
        </div>
      </div>
    );
  }
};

export default Select;